import { Link } from "react-router-dom";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";

const CompanyMenu = () => {
  return (
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuTrigger className="text-white/80 hover:text-white transition-colors text-base bg-transparent">
            Company
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <div className="grid w-[200px] gap-3 p-4 bg-background/95 backdrop-blur-lg border border-white/10">
              <NavigationMenuLink asChild>
                <Link
                  to="/about-us"
                  className={cn(
                    "block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors",
                    "hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  )}
                >
                  <div className="text-sm font-medium leading-none text-white">About Us</div>
                  <p className="line-clamp-2 text-sm leading-snug text-white/70">
                    Learn about our mission and values
                  </p>
                </Link>
              </NavigationMenuLink>
              <NavigationMenuLink asChild>
                <Link
                  to="/team"
                  className={cn(
                    "block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors",
                    "hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  )}
                >
                  <div className="text-sm font-medium leading-none text-white">Team</div>
                  <p className="line-clamp-2 text-sm leading-snug text-white/70">
                    Meet our founders and advisors
                  </p>
                </Link>
              </NavigationMenuLink>
            </div>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
};

export default CompanyMenu;